exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map {\n  width: 100%;\n  height: 150px;\n}\n.id {\n  font-size: .8em;\n  padding-left: 5px;\n  color: #b2b2b2;\n}\n.location-pill {\n  margin-right: 5px;\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports
